module.exports = __webpack_public_path__ + "img/Group 139.ddf5c147.svg";